<template>
    <div class="productMenuBlock">
        <div class="product-category-content-wrapper">
            <div class="row">
                <div class="col-lg-12 dis-flex mb-4 p-lr-0-sm element-forms-selecting desctop-options-menu">
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'baltics'" :class="{'active-btn': selectedMenu == 'baltics'}">
                        <i class="fa fa-globe mr-2"></i>Baltics
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'europe'" :class="{'active-btn': selectedMenu == 'europe'}">
                        <i class="fa fa-globe mr-2"></i>Europe
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'usa'" :class="{'active-btn': selectedMenu == 'usa'}">
                        <i class="fa fa-globe mr-2"></i>United States
                    </button>
                </div>

                <div class="col-lg-12 mb-4 p-lr-0-sm element-forms-selecting mobile-options-menu">
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'baltics'" :class="{'active-btn': selectedMenu == 'baltics'}" attr="Baltics">
                        <i class="fa fa-globe"></i>
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'europe'" :class="{'active-btn': selectedMenu == 'europe'}" attr="Europe">
                        <i class="fa fa-globe"></i>
                    </button>
                    <button type="button" class="btn btn-element" @click="selectedMenu = 'usa'" :class="{'active-btn': selectedMenu == 'usa'}" attr="United States">
                        <i class="fa fa-globe"></i>
                    </button>
                </div>
            </div>

            <balticClients v-if="selectedMenu == 'baltics'"></balticClients>
            <europeClients v-else-if="selectedMenu == 'europe'"></europeClients>
            <usaClients v-else-if="selectedMenu == 'usa'"></usaClients>
           
        </div>
    </div>
</template>

<script>
import baclticClientsVue from './balticClients.vue';
import europeClientsVue from './europeClients.vue';
import usaClientsVue from './usaClients.vue';

export default {
    components: {
        balticClients: baclticClientsVue,
        europeClients: europeClientsVue,
        usaClients: usaClientsVue
    },
    data() {
        return {
            selectedMenu: 'baltics',
        }
    },
}

</script>

<style>

</style>